import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';

class Spinner {
  spinner$ = new BehaviorSubject<boolean>(false);

  setSpinner(spinner: boolean): void {
    this.spinner$.next(spinner);
  }
}
export default new Spinner();
